import { FC, PropsWithChildren } from 'react';
import { QueryClient, QueryClientProvider, useQuery as useOriginalQuery, UseQueryOptions } from 'react-query';

export const QueryProvider: FC<PropsWithChildren> = ({ children }) => {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: { suspense: true, staleTime: Infinity, cacheTime: Infinity, refetchOnWindowFocus: false }
    }
  });

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export function useQuery<T>(
  key: string[],
  queryFn: () => Promise<T>,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) {
  const result = useOriginalQuery(key, async () => await queryFn(), options);
  return [result.data as T, result] as const;
}
